/**
 * @generated SignedSource<<2f89d8f3ce2f72faaf9ec2a4ab304593>>
 * @relayHash bafe6d90d9a3b53248e4e2eed684f730
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d3d33641f3850aec5924fd6952fe96ee472e92a76da12924af5df6d791378e2e

import type { ConcreteRequest, Query } from 'relay-runtime';
export type KnowledgeGraphContentType = "BLOGPOST" | "PAGE" | "%future added value";
export type aiSnippetLoaderQuery$variables = {
  cloudId: string;
  contentId: string;
  contentType: KnowledgeGraphContentType;
};
export type aiSnippetLoaderQuery$data = {
  readonly confluence_latestKnowledgeGraphObjectV2: {
    readonly __typename: "KnowledgeGraphObjectResponseV2";
    readonly objectData: string;
  } | null | undefined;
};
export type aiSnippetLoaderQuery = {
  response: aiSnippetLoaderQuery$data;
  variables: aiSnippetLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentType"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "contentType",
        "variableName": "contentType"
      },
      {
        "kind": "Literal",
        "name": "objectType",
        "value": "snippet_v2"
      }
    ],
    "concreteType": "KnowledgeGraphObjectResponseV2",
    "kind": "LinkedField",
    "name": "confluence_latestKnowledgeGraphObjectV2",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "ScalarField",
        "name": "objectData"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "aiSnippetLoaderQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "aiSnippetLoaderQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "d3d33641f3850aec5924fd6952fe96ee472e92a76da12924af5df6d791378e2e",
    "metadata": {},
    "name": "aiSnippetLoaderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b9efb7ec5661a8a247093e5e0b7e9190";

export default node;
